import { ProductTemplateConfigType } from '#src/utils';

export const payByLinkVoucherConfig: ProductTemplateConfigType = {
  dynamicComponents: {
    HEADER: {
      params: {
        title: {
          contentKey: 'paymentpage.paybylink.page.voucher.title',
        },
        backButton: {
          isVisible: false,
        },
      },
      template: 'primaryBackground',
    },
  },
};

export const payByLinkPtcRedirectionConfig: ProductTemplateConfigType = {
  dynamicComponents: {
    HEADER: {
      params: {
        title: {
          contentKey: 'paymentpage.paybylink.page.default.title',
        },
        backButton: {
          isVisible: false,
        },
      },
      template: 'primaryBackground',
    },
  },
};

export const payByLinkCustomerSupportConfig: ProductTemplateConfigType = {
  dynamicComponents: {
    HEADER: {
      params: {
        title: {
          contentKey: 'paymentpage.paybylink.page.customerSupport.title',
        },
        backButton: {
          isVisible: false,
        },
      },
      template: 'primaryBackground',
    },
  },
};
